module.exports = __webpack_public_path__ + "static/media/text.ab173580.png";